module.exports = __webpack_public_path__ + "static/media/Because-Logo-White.0d227996.png";